// src/Pages/Load/LoadContainer/utils/date.js

export const formatDateToBR = (dateString) => {
  if (!dateString) {
    return "N/A";
  }

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // Mantém o formato que você já usa hoje (MM/DD/YYYY)
  return `${month}/${day}/${year}`;
};